<template>
  <div
    v-if="data"
    class="w-80 shrink-0 flex-col border-r transition-all"
    :class="{ '-ml-80': !isOpen }"
  >
    <div class="flex items-center justify-between border-b px-6 py-5 text-sm">
      <span>{{ $t('your_details', 'Your details') }}</span>
      <button
        type="button"
        :title="$t('close', 'Close')"
        class="text-base text-supplement transition-colors hover:text-paragraph"
        @click="isOpen = false"
      >
        <Icon
          icon="sidebar"
          prefix="fal"
        />
      </button>
    </div>
    <LazyCopilotLiveEditor
      v-model:first-name="data.advisor.first_name"
      v-model:last-name="data.advisor.last_name"
      v-model:phone="data.advisor.phone"
      v-model:logo="data.advisor.logo"
      v-model:personal-photo="data.advisor.personal_photo"
    />
  </div>
</template>

<script setup lang="ts">
import type { CopilotPage } from '~/pages/[partner_slug]/website.vue'

const props = defineProps<{
  partnerSlug: string
}>()

// Same data as the website page, so edits update its preview
const { data } = useNuxtData<CopilotPage>(`copilot-${props.partnerSlug}`)
const isOpen = useCopilotEditorOpen()
</script>
